import { FormikValues } from 'formik'

export interface UpdateRatingComplianceRuleValues extends FormikValues {
  id: number
  rating: string
  ratingType: string
  maxLimit: number
}

export const updateRatingComplianceRuleValues: UpdateRatingComplianceRuleValues = {
  id: 0,
  rating: null,
  ratingType: null,
  maxLimit: 0,
}
